import { BaseButton } from 'app/components/buttons/BaseButton';
import {
  AccessSharingAddIcon,
  AccessSharingDoneIcon,
} from 'app/components/icons';
import React, { useCallback, useState } from 'react';
import { IEquipmentEntry } from 'types/IEquipmentEntry';
import './EquipmentAccessSharingButton.less';
import { EquipmentAccessSharingDialog } from 'app/pages/Equipment/EquipmentContent/components';
import clsx from 'clsx';

interface Props {
  className?: string;
  equipment: IEquipmentEntry;
}

export default function EquipmentAccessSharingButton({
  className,
  equipment,
}: Props) {
  const isShared =
    equipment?.isSharedIndividually || equipment?.isSharedAsPartOfFleet;

  const [anchorEl, setAnchorEl] = useState<HTMLElement>();

  const handleMenuClose = useCallback(() => {
    setAnchorEl(undefined);
  }, []);

  const handleMenuOpen = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      const element = event.currentTarget;
      setAnchorEl(element);
    },
    [],
  );

  return (
    <>
      <BaseButton
        className={clsx(className, 'ellipsis-menu__button', {
          'ellipsis-menu__button_open': anchorEl,
        })}
        onClick={handleMenuOpen}
      >
        {isShared ? <AccessSharingDoneIcon /> : <AccessSharingAddIcon />}
      </BaseButton>

      <EquipmentAccessSharingDialog
        anchor={anchorEl}
        equipment={equipment}
        onClose={handleMenuClose}
      />
    </>
  );
}
